import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HomeSnak } from '../interface/helper.interface';

@Injectable({
  providedIn: 'root'
})

export class HelperService {

  constructor() { }

  authSnakBar = new BehaviorSubject<string>('');
  homeSnakBar = new BehaviorSubject< HomeSnak | null>(null);
  mapStopExpandedPanel = new BehaviorSubject<string>('');
  homeDialogSubject = new BehaviorSubject<{title:string,body:string} | null>(null);
}
